"use client";

import { SWRConfig } from "swr";
import { useAuth } from "../client/hooks/useAuth";

// biome-ignore lint/suspicious/noExplicitAny: SWR fetcher can return any type
const fetcher = async (...args: [input: RequestInfo, init?: RequestInit]): Promise<any> => {
  const res = await fetch(...args);

  if (!res.ok) {
    const error: any = new Error("An error occurred while fetching the data.");
    error.status = res.status;
    try {
      error.info = await res.json();
    } catch (e) {
      error.info = res.statusText;
    }
    throw error;
  }

  return res.json();
};

export function SWRProvider({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();

  return (
    <SWRConfig
      value={{
        fetcher,
        onError: async (error) => {
          if (error.status === 401) {
            await logout();
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
